// src/components/HowItWorksSection.jsx
import React from 'react';

const Features = (props) => {
    const content = props.content || {};
    return (
        <section id="features" className=" w-full relative flex flex-col items-center justify-center">

            {/* Content */}
            {/* Features Repeater */}
            <div className="flex flex-col justify-center items-center w-full h-auto z-10 space-y-2">
                {content.features.items.map((item, index) => (
                    <div className={`w-full ${index % 2 === 1 ? "bg-pf-bglight" : "bg-pf-bgDarker"}`} key={index}>
                        <div className={`wrapper h-auto flex flex-row items-center justify-center flex-wrap py-10 ${index % 2 === 1 ? "md:flex-row-reverse" : ""}`}>
                            <div className="w-full text-pf-titleDark text-center text-subtitle-sm md:hidden px-6 py-2">
                                {item.item.title}
                            </div>
                            <div className='w-full md:w-1/2 relative overflow-hidden p-4'>
                                <img src={item.item.imageUrl} className="w-full md:w-8/12 mx-auto rounded-2xl" alt="feature-thumb" />
                            </div>
                            <div className='w-full md:w-1/2 flex flex-col items-center justify-center'>
                                <div className="hidden md:block text-pf-titleDark text-center text-subtitle-sm md:text-subtitle md:px-20 md:py-8 px-6 py-8">
                                    {item.item.title}
                                </div>
                                <div className='text-xl font-normal text-pf-titleDark w-full px-5 md:px-20 pt-2'>
                                    {item.item.body}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Features;